var _rect, _g, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path, _circle, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283,
    height: 249,
    viewBox: "0 0 283 249",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 12,
    width: 218,
    height: 218,
    rx: 16,
    fill: "#C8EAE4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_740_8200)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 91,
    width: 133,
    height: 59.27,
    rx: 4,
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 189.091,
    y: 96.9091,
    width: 26.5909,
    height: 7.38636,
    rx: 3.69318,
    fill: "#D7D8DA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 221.591,
    y: 96.9091,
    width: 26.5909,
    height: 7.38636,
    rx: 3.69318,
    fill: "#D7D8DA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 189.091,
    y: 123.5,
    width: 7.38636,
    height: 7.38636,
    rx: 3.69318,
    fill: "#D7D8DA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 202.386,
    y: 123.5,
    width: 7.38636,
    height: 7.38636,
    rx: 3.69318,
    fill: "#D7D8DA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 215.682,
    y: 123.5,
    width: 14.7727,
    height: 7.38636,
    rx: 3.69318,
    fill: "#D7D8DA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 189.091,
    y: 136.795,
    width: 48.75,
    height: 7.38636,
    rx: 3.69318,
    fill: "#D7D8DA"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 189.091,
    y: 110.204,
    width: 67.9545,
    height: 7.38636,
    rx: 3.69318,
    fill: "#D7D8DA"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 135.909,
    y: 97,
    width: 47.2727,
    height: 47.2727,
    rx: 4,
    fill: "#13C2C2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.273 120.545C177.273 130.336 169.336 138.273 159.546 138.273C149.755 138.273 141.818 130.336 141.818 120.545C141.818 110.755 149.755 102.818 159.546 102.818C169.336 102.818 177.273 110.755 177.273 120.545ZM149.354 132.239C152.079 134.616 155.644 136.057 159.546 136.057C163.447 136.057 167.012 134.616 169.738 132.239C169.16 131.678 168.388 130.986 167.467 130.295C165.327 128.69 162.517 127.193 159.546 127.193C156.575 127.193 153.764 128.69 151.624 130.295C150.703 130.986 149.931 131.678 149.354 132.239ZM147.791 130.667C145.45 127.95 144.034 124.413 144.034 120.545C144.034 111.979 150.979 105.034 159.546 105.034C168.112 105.034 175.057 111.979 175.057 120.545C175.057 124.413 173.641 127.95 171.3 130.667C170.667 130.051 169.817 129.288 168.797 128.523C166.506 126.804 163.222 124.977 159.546 124.977C155.869 124.977 152.586 126.804 150.294 128.523C149.274 129.288 148.424 130.051 147.791 130.667ZM159.546 122.761C163.217 122.761 166.193 119.785 166.193 116.114C166.193 112.442 163.217 109.466 159.546 109.466C155.874 109.466 152.898 112.442 152.898 116.114C152.898 119.785 155.874 122.761 159.546 122.761ZM159.546 111.682C161.993 111.682 163.977 113.666 163.977 116.114C163.977 118.561 161.993 120.545 159.546 120.545C157.098 120.545 155.114 118.561 155.114 116.114C155.114 113.666 157.098 111.682 159.546 111.682Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_740_8200",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 49,
    width: 144,
    height: 144
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 126,
    cy: 121,
    r: 68,
    fill: "#C4C4C4",
    stroke: "#AFB2B6",
    strokeWidth: 8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_740_8200)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_740_8200)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.0186,
    y: 64.27,
    width: 252.963,
    height: 112.73,
    rx: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_740_8200)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.0186,
    y: 64.27,
    width: 252.963,
    height: 112.73,
    rx: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 182.408,
    y: 75.5089,
    width: 50.5752,
    height: 14.0487,
    rx: 4,
    fill: "#D7D8DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.408,
    y: 126.084,
    width: 14.0487,
    height: 14.0487,
    rx: 4,
    fill: "#D7D8DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.408,
    y: 151.372,
    width: 92.7212,
    height: 14.0487,
    rx: 4,
    fill: "#D7D8DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.408,
    y: 100.796,
    width: 129.248,
    height: 14.0487,
    rx: 4,
    fill: "#D7D8DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.2568,
    y: 75.6819,
    width: 89.9115,
    height: 89.9115,
    rx: 4,
    fill: "#13C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.4966 93.0697C92.4966 89.5782 95.327 86.7478 98.8185 86.7478H136.75C140.241 86.7478 143.072 89.5782 143.072 93.0697V131.001C143.072 134.493 140.241 137.323 136.75 137.323H98.8185C95.327 137.323 92.4966 134.493 92.4966 131.001V93.0697ZM98.8185 90.9624C97.6547 90.9624 96.7112 91.9059 96.7112 93.0697V107.821H103.236L109.553 94.2859C109.912 93.517 110.696 93.0383 111.544 93.0713C112.392 93.1043 113.137 93.6426 113.435 94.4371L124.318 123.457L129.08 113.252C129.427 112.51 130.171 112.035 130.99 112.035H138.857V93.0697C138.857 91.9059 137.914 90.9624 136.75 90.9624H98.8185ZM104.578 112.035H96.7112V131.001C96.7112 132.165 97.6547 133.108 98.8185 133.108H136.75C137.914 133.108 138.857 132.165 138.857 131.001V116.25H132.332L126.016 129.785C125.657 130.554 124.872 131.033 124.024 131C123.176 130.966 122.431 130.428 122.133 129.634L111.251 100.614L106.488 110.819C106.142 111.561 105.397 112.035 104.578 112.035ZM149.394 95.177C150.558 95.177 151.501 96.1205 151.501 97.2843V139.43C151.501 142.922 148.671 145.752 145.179 145.752H103.033C101.869 145.752 100.926 144.809 100.926 143.645C100.926 142.481 101.869 141.538 103.033 141.538H145.179C146.343 141.538 147.286 140.594 147.286 139.43V97.2843C147.286 96.1205 148.23 95.177 149.394 95.177ZM157.823 103.606C158.987 103.606 159.93 104.55 159.93 105.714V147.86C159.93 151.351 157.1 154.181 153.608 154.181H111.462C110.298 154.181 109.355 153.238 109.355 152.074C109.355 150.91 110.298 149.967 111.462 149.967H153.608C154.772 149.967 155.716 149.023 155.716 147.86V105.714C155.716 104.55 156.659 103.606 157.823 103.606Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dd_740_8200)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 126,
    cy: 121,
    r: 68,
    stroke: "#AFB2B6",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 214.5L73.5 165",
    stroke: "#AFB2B6",
    strokeWidth: 8,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_740_8200",
    x: 110,
    y: 81,
    width: 173,
    height: 99.27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_740_8200"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_740_8200",
    result: "effect2_dropShadow_740_8200"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_740_8200",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_740_8200",
    x: 50.0186,
    y: 54.27,
    width: 292.962,
    height: 152.73,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_740_8200"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_740_8200",
    result: "effect2_dropShadow_740_8200"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_740_8200",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_740_8200",
    x: 50.0186,
    y: 54.27,
    width: 292.962,
    height: 152.73,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_740_8200"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_740_8200",
    result: "effect2_dropShadow_740_8200"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_740_8200",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dd_740_8200",
    x: 0,
    y: 39,
    width: 218,
    height: 209.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_740_8200"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_740_8200",
    result: "effect2_dropShadow_740_8200"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_740_8200",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRecord);
export default __webpack_public_path__ + "static/media/no-record.efdf576f6e18c2303daa91cf1b3e4b2c.svg";
export { ForwardRef as ReactComponent };